import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../models';

/** Representa o Filter de pesquisa da entidade Meta */
export class MetaFilterSearch implements Filter {
    controleQuantidade: boolean;
    controlePeso: boolean;
    controleValor: boolean;
    idsClassificacoes: number[] = [];
    classificacaoNull = false;
    data: Date;
    mes: number;
    ano: number;
    idsRepresentantes: number[] = [];
    somenteRepresentantesAtivos = true;

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Controle Por Quantidade
        if (this.controleQuantidade !== undefined && this.controleQuantidade != null) {
            params = params.append('controleQuantidade', this.controleQuantidade.toString());
        }

        // Controle Por Peso
        if (this.controlePeso !== undefined && this.controlePeso != null) {
            params = params.append('controlePeso', this.controlePeso.toString());
        }

        // Controle Por Valor
        if (this.controleValor !== undefined && this.controleValor != null) {
            params = params.append('controleValor', this.controleValor.toString());
        }

        // Classificações
        this.idsClassificacoes?.forEach(idClassificacao => {
            if (idClassificacao > 0) {
                params = params.append('idClassificacao', idClassificacao.toString());
            }
        });
        // Sem classificação
        if (this.classificacaoNull) {
            params = params.append('classificacaoNull', 'true');
        }

        // Mês
        if (this.mes) {
            params = params.append('mes', this.mes.toString());
        }
        // Ano
        if (this.ano) {
            params = params.append('ano', this.ano.toString());
        }
        // Representantes
        this.idsRepresentantes?.forEach(idRepresentante => {
            params = params.append('idRepresentante', idRepresentante.toString());
        });

        return params;
    }

    clear() {
        this.controleQuantidade = null;
        this.controlePeso = null;
        this.controleValor = null;
        this.idsClassificacoes = [];
        this.classificacaoNull = false;
        this.data = null;
        this.mes = null;
        this.ano = null;
        this.idsRepresentantes = [];
        this.somenteRepresentantesAtivos = true;
    }
}

